export type TColors =
  | 'pink'
  | 'graphite'
  | 'gray'
  | 'white'
  | 'green'
  | 'black'
  | 'grass'
  | 'steelGray'
  | 'lightGray'
  | 'middleGray'
  | 'darkGray'
  | 'blue'
  | 'blueSky'
  | 'darkBlue'
  | 'orange'
  | 'darkGreen'
  | 'red'
  | 'darkRed'

export type TColorVariables = {
  [key in TColors]: string
}

const colorVariables: TColorVariables = {
  pink: '#FFE7E3',
  orange: '#F4822A',
  white: '#FFFFFF',
  graphite: '#333F48',
  black: '#000000',
  grass: '#00D900',
  gray: '#878B90',
  middleGray: '#CDD2D6',
  green: '#21A038',
  steelGray: '#E2E6EC',
  darkGreen: '#1A802D',
  lightGray: '#F0F3F6',
  darkGray: '#878B90',
  blue: '#3470AA',
  blueSky: '#C8DBFF',
  darkBlue: '#0253A2',
  red: '#EF4B3F',
  darkRed: '#D13939',
}

export default colorVariables
